export default __webpack_public_path__ + "static/media/plusBtn.b9fdb132.svg";